import $ from 'jquery';

const clearFormOnSuccess = () => {
  $('#footerNewsletterEmail').val('');
  $('#footerNewsletterFirstname').val('');
  $('#footerNewsletterLastname').val('');
};

const postSubscribeForm = () => {
  return $.post('api/v1/contact/subscribe', {
    Identifier: $('#footerNewsletterEmail').val(),
    Email: $('#footerNewsletterEmail').val(),
    Firstname: $('#footerNewsletterFirstname').val(),
    Lastname: $('#footerNewsletterLastname').val(),
    Corporate: $('input[name=corporate]:checked').val(),
    BankRegNr: $('#bankRegNr').val(),
  });
};

export const init = () => {
  const $button = $('#footerNewsletterButtonSubscribe');
  const $feedbackMessageSuccess = $('#feedbackMessageSuccess');
  const $feedbackMessageError = $('#feedbackMessageError');
  const buttonText = $button.text();
  const buttonBusyText = $button.attr('data-busy-text');
  $button.click((ev) => {
    ev.preventDefault();
    $button.attr('disabled', 'disabled');
    $button.text(buttonBusyText);

    postSubscribeForm().then(() => {
      $feedbackMessageSuccess.show();
      clearFormOnSuccess();
    }, () => {
      $feedbackMessageError.show();
    }).always(() => {
      $button.removeAttr('disabled');
      $button.text(buttonText);
    });
  });
};
